module.exports = __webpack_public_path__ + "atul-d819a83dd1287bd80b5c.jpg";